import { loadSession, saveSession, removeSession } from '@helpers/sessionStorage';

const TRACK_BMP_LIST_VALUE = 'bmp_list';

export const getBmpListValue = () => loadSession(TRACK_BMP_LIST_VALUE);

export const setBmpListValue = (value) => {
    saveSession(TRACK_BMP_LIST_VALUE, value);
};

export const removeBmpListValue = () => removeSession(TRACK_BMP_LIST_VALUE);

export const bmpListTracker = () => {
    if (App.Config.Controller !== 'product') {
        removeBmpListValue();
    }
};
